import React, { PropsWithChildren } from "react";
//#region types
import { InlineLabelLayoutProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const InlineLabelLayout: React.FC<PropsWithChildren<InlineLabelLayoutProps>> = (props) => {
  return (
    <Grid
      item
      container
      lg={props.columns ?? 3}
      direction="column"
      justifyContent={props.verticalAlignCenter ? "center" : "flex-start"}
      alignItems={props.horizontalAlignment}
      className={cssExports.formControlLabelContainer}
    >
      {props.children}
    </Grid>
  );
};

export default InlineLabelLayout;
